module.exports = __webpack_public_path__ + "img/8e36204.png";